import React, {
  Fragment,
  useContext,
  useState,
  useEffect,
  useRef,
} from "react";
import { useHistory } from "react-router-dom";
import useTokenCheck from "../../hooks/useTokenCheck";
import AuthContext from "../../context/auth/AuthContext";
import AlertContext from "../../context/alert/AlertContext";
import ConfigContext from "../../context/config/ConfigContext";
import CardContext from "../../context/card/CardContext";
import NavigationContext from "../../context/navigation/NavigationContext";
import useForm from "../../hooks/useForm";
import Preloader from "./../layout/Preloader";
import ActionMenu from "./../layout/ActionMenu";
import { getStateCode, getStateByCode } from "./../../utils/Lookup";
import Address from "../common/Address";
import ChangePassword from "./ChangePassword";
import ModalDialog from "../common/ModalDialog";
import usePageTitle from "../../hooks/usePageTitle";
import CartContext from "../../context/cart/CartContext";
import SubscribeContext from "../../context/subscribe/SubscribeContext";
import GroupContext from "../../context/group/GroupContext";
import EmployeeContext from "../../context/employee/EmployeeContext";
import CompCardContext from "../../context/comp-card/CompCardContext";

const Account = (props) => {
  const authContext = useContext(AuthContext);
  const configContext = useContext(ConfigContext);
  const cardContext = useContext(CardContext);
  const cartContext = useContext(CartContext);
  const alertContext = useContext(AlertContext);
  const navigationContext = useContext(NavigationContext);
  const subscribeContext = useContext(SubscribeContext);
  const groupContext = useContext(GroupContext);
  const employeeContext = useContext(EmployeeContext);
  const compCardContext = useContext(CompCardContext);

  const {
    user,
    isAuthenticated,
    loading,
    token,
    changePassword,
    updateProfile,
    loadUser,
    logoutThroughChangePassword,
  } = authContext;
  const { getConfigValueByCode, resetConfigState } = configContext;
  const { loadUserCards, isLoading, loaded, error, resetCardState } =
    cardContext;
  const { resetCartState } = cartContext;
  const { setAlert, clearAlerts } = alertContext;
  const { fieldRefs } = navigationContext;
  const { resetSubscribeState } = subscribeContext;
  const { resetGroupState } = groupContext;
  const { resetEmployeeState } = employeeContext;
  const { resetCompCardState } = compCardContext;

  const history = useHistory();
  const [mode, setMode] = useState("View");
  const [valueChanged, setValueChanged] = useState(false);
  const [password, setPasword] = useState({
    existingpassword: "",
    newpassword: "",
    confirmPassword: "",
  });
  //eslint-disable-next-line

  const [showDialog, setShowDialog] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const { hasTokenExpired } = useTokenCheck();
  usePageTitle({
    appTitle: props.appTitle,
    pageTitle: "Account",
  });
  const onClose = async () => {
    setShowDialog(false);
    props.resetUseIdleTimer();
    clearAlerts();
    resetCardState();
    resetCartState();
    resetSubscribeState();
    resetGroupState();
    resetEmployeeState();
    resetCompCardState();
    resetConfigState();
    logoutThroughChangePassword();
    history.push("/");
    // try {
    //   await logout(token);
    //   history.push("/");
    // } catch (err) {
    //   const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 465);
    //   setAlert(msg, "danger");
    //   history.push("/");
    // }
  };

  let { existingpassword, newpassword } = password;
  // const existingpasswordRef = useRef(null);
  // const newpasswordRef = useRef(null);
  // const confirmPasswordRef = useRef(null);
  const [passwordFieldRefs, setPasswordFieldRefs] = useState(null);
  // let inputList = {};
  const newpassRef = useRef();
  newpassRef.current = newpassword;
  const isConfirmPasswordMatching = (value) => {
    console.log("COnfirm pass to match", value);
    let isMatching = false;
    if (newpassRef.current) isMatching = newpassRef.current === value;

    return !isMatching ? " is not matching" : "";
  };

  const {
    Popup,
    validateField,
    validateAllFields,
    isFormValid,
    setIsFormValid,
    setValidationControl,
  } = useForm({
    inputList: passwordFieldRefs,
    customRules: {
      confirmPassword: isConfirmPasswordMatching,
    },
    screenName: "change_password",
  });

  useEffect(() => {
    const isValid = validateAllFields();
    setIsFormValid(isValid);
    console.log("Form is valid", isValid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [password]);

  useEffect(() => {
    console.log("@@Mode ", mode);
  }, [mode]);

  const passwordChange = (e) => {
    // console.log("Form field", e.target.name);
    // console.log("Form field value", e.target.value);
    // console.log("Existing password", password);
    // console.log("Existing password value", password["newpassword"]);
    setPasword({ ...password, [e.target.name]: e.target.value });
  };

  const [address, setAddress] = useState({
    address1: "",
    address2: "",
    city: "",
    state: "",
    zipcode: "",
    phonenumber: "",
  });
  const [addressFieldRefs, setAddressFieldRefs] = useState(null);

  const {
    Popup: PopupAddress,
    validateField: validateAddressField,
    validateAllFields: validateAllAddressFields,
    isFormValid: isAddressFormValid,
    setIsFormValid: setIsAddressFormValid,
    setValidationControl: setAddressValidationControl,
    unformattedValues,
    setUnformattedValues,
  } = useForm({
    inputList: addressFieldRefs,
    unformattedValuesList: {
      phonenumber: "",
    },
    screenName: "update_profile",
  });

  const addressFromDb = () => {
    setAddress({
      address1: user.address.split(", ")[0],
      address2: user.address.split(", ")[1],
      city: user.town,
      state: getStateCode(user.state),
      zipcode: user.zipcode,
      phonenumber: user.phoneNumber,
    });
    setValueChanged(false);
  };

  useEffect(() => {
    addressFromDb();
    setUnformattedValues({
      ...unformattedValues,
      phonenumber: user.phoneNumber,
    });
    if (
      user &&
      !user.sponsor &&
      isAuthenticated &&
      !error &&
      !loaded &&
      !isLoading
    ) {
      console.log("Loading user Cards...");
      loadUserCards({}, token);
    }
    console.log("Account Page reset...");
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    console.log("field refs", fieldRefs);
    if (fieldRefs && fieldRefs["change_password"]) {
      console.log(
        "Assiging change password refs",
        fieldRefs["change_password"]
      );
      setPasswordFieldRefs(fieldRefs["change_password"]);
      setValidationControl(fieldRefs["change_password"]);
    }
    if (fieldRefs && fieldRefs["address"]) {
      console.log(
        "Assiging change password refs",
        fieldRefs["change_password"]
      );
      setAddressFieldRefs(fieldRefs["address"]);
      setAddressValidationControl(fieldRefs["address"]);
    }
    //eslint-disable-next-line
  }, [fieldRefs]);

  let { address1, address2, city, state, zipcode, phonenumber } = address;

  useEffect(() => {
    const isValid = validateAllAddressFields();
    setIsAddressFormValid(isValid);
    console.log("Form is valid", isValid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address]);

  const addressChange = (e) => {
    setAddress({ ...address, [e.target.name]: e.target.value });
    if (e.target.name === "state") {
      console.log("State val:", e.target.value);
      console.log("Address:::", address);
    }
    setValueChanged(true);
  };

  const phoneNoChange = (value, floatValue) => {
    console.log("Formatted Value", value);
    console.log("UnFormatted Value", floatValue);
    setAddress({ ...address, phonenumber: value });
    setUnformattedValues({
      ...unformattedValues,
      phonenumber: floatValue?.toString(),
    });
    setValueChanged(true);
  };

  const modeChange = async (e) => {
    await hasTokenExpired();
    console.log("ModeChange: ", e.target.name);
    if (mode === e.target.name) {
      submitForm(e.target.name, e);
      setValueChanged(false);
    }
    setMode(e.target.name);
  };

  const cancelAction = () => {
    addressFromDb();
    console.log("Cancel Action: ");
    setMode("View");
  };

  const submitForm = async (formType, e) => {
    setIsProcessing(true);
    if (formType === "UpdatePassword") {
      console.log("Submitting change password");
      const password = {
        existingpassword: existingpassword,
        newpassword,
      };
      try {
        const res = await changePassword(password, token);
        console.log("$$RES: ", res);
        const msg = getConfigValueByCode(
          "generalConfig",
          "RESPONSE_MSG",
          res.msgCode
        );
        clearAlerts();
        setAlert(msg, res.status === "ERROR" ? "danger" : "info");
        if (res.status === "SUCCESS") {
          setShowDialog(true);
        }
      } catch (err) {
        console.log("$ERR:", err.message);
        // const msg = getConfigValueByCode(
        //   "generalConfig",
        //   "RESPONSE_MSG",
        //   500
        // );
        clearAlerts();
        const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
        setAlert(msg, "danger");
      }
    } else if (formType === "UpdateProfile") {
      console.log("Submitting change profile");
      const address = {
        address1,
        address2,
        city,
        state: getStateByCode(state),
        zipcode,
        phonenumber,
      };
      console.log("Address: ", address);
      try {
        let res = await updateProfile(address, token);
        if (res.status === "SUCCESS") {
          await loadUser({}, token);
        }
        const msg = getConfigValueByCode(
          "generalConfig",
          "RESPONSE_MSG",
          res.msgCode
        );
        clearAlerts();
        setAlert(msg, res.status === "ERROR" ? "danger" : "info");
        // if (res.status !== "ERROR") {
        // }
        setMode("View");
      } catch (err) {
        console.log("$ERR:", err.message);
        // const msg = getConfigValueByCode(
        //   "generalConfig",
        //   "RESPONSE_MSG",
        //   500
        // );
        clearAlerts();
        const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
        setAlert(msg, "danger");
      }
    }
    setIsProcessing(false);
  };

  // const isAddressReadyToSubmit = (e) => {
  //   e.preventDefault();
  //   if (
  //     address1 === "" ||
  //     city === "" ||
  //     state === "" ||
  //     zipcode === "" ||
  //     phonenumber === ""
  //   ) {
  //     clearAlerts();
  //      setAlert("Please fill in all fields", "danger");
  //     return false;
  //   } else {
  //     clearAlerts();
  //     return true;
  //   }
  // };
  // const isPasswordReadyToSubmit = (e) => {
  //   e.preventDefault();
  //   if (
  //     (existingpassword === "" ||
  //       newpassword === "" ||
  //       confirmPassword === "") &&
  //     newpassword === confirmPassword
  //   ) {
  //     clearAlerts();
  //     setAlert("Please fill in all fields", "danger");
  //     return false;
  //   } else {
  //     clearAlerts();
  //     return true;
  //   }
  // };

  return (
    <Fragment>
      <Popup role="alert" aria-relevant="all" />
      <PopupAddress />
      {showDialog && (
        <ModalDialog
          show={showDialog}
          onSubmit={onClose}
          title={"Note"}
          message={"Please login to the application with the new password"}
          submitLabel={"OK"}
          turnOffCancel={true}
          role="alert"
          aria-relevant="all"
        />
      )}
      {(loading || isProcessing) && <Preloader />}
      <ActionMenu resetUseIdleTimer={props.resetUseIdleTimer} />
      <div
        className="patronPage"
        role="main"
        ref={props.mainContentRef}
        tabIndex="-1"
      >
        <h1 id="pageHeader" className="patronPage__pageTitle">
          ACCOUNT INFORMATION
        </h1>
        <div className="patronPage__content">
          <div className="patronPage__card_row_4_col_2">
            <h2 className="patronPage__cardTitle">LOGIN INFORMATION</h2>
            <div className="patronPage__card_item_title">Name: </div>
            <div className="patronPage__card_item">{user.email}</div>
            <div className="patronPage__card_item_title"> Password: </div>
            <div className="patronPage__card_item">*******</div>
            <div className="patronPage__card_form">
              {mode === "UpdatePassword" && (
                <Fragment>
                  <div className="patronPage__card_form__title">
                    UPDATE PASSWORD
                  </div>
                  <div>
                    <ChangePassword
                      password={password}
                      passwordChange={passwordChange}
                      onBlur={validateField}
                    />
                  </div>
                </Fragment>
              )}
            </div>
            <div
              className="patronPage__card_action_bottom"
              aria-live="assertive"
            >
              {mode === "UpdatePassword" && (
                <input
                  className="btn btn-primary"
                  type="button"
                  value="BACK"
                  onClick={cancelAction}
                ></input>
              )}
              <input
                className="btn btn-primary"
                name="UpdatePassword"
                type="button"
                value="CHANGE PASSWORD"
                onClick={modeChange}
                disabled={mode === "UpdatePassword" && !isFormValid}
              ></input>
            </div>
          </div>
          <div className="patronPage__card_row_5_col_2">
            <h2 className="patronPage__cardTitle ">PROFILE INFORMATION</h2>
            <div className="patronPage__card_item_title">Name: </div>
            <div className="patronPage__card_item">
              {user.firstName + " " + user.lastName}
            </div>
            <div className="patronPage__card_item_title"> Address: </div>
            <div className="patronPage__card_item">
              {user.address +
                " " +
                user.town +
                " " +
                user.state +
                " " +
                user.zipcode}
            </div>
            <div className="patronPage__card_item_title"> Phone: </div>
            <div className="patronPage__card_item">{user.phoneNumber}</div>
            <div className="patronPage__card_form">
              {mode === "UpdateProfile" && (
                <Fragment>
                  <div className="patronPage__card_form__title">
                    UPDATE PROFILE
                  </div>
                  <div>
                    <Address
                      address={address}
                      addressChange={addressChange}
                      phoneNoChange={phoneNoChange}
                      onBlur={validateAddressField}
                    />
                  </div>
                </Fragment>
              )}
            </div>
            <div className="patronPage__card_action_bottom">
              {mode === "UpdateProfile" && (
                <input
                  className="btn btn-primary"
                  type="button"
                  value="BACK"
                  onClick={cancelAction}
                ></input>
              )}
              <input
                className="btn btn-primary"
                name="UpdateProfile"
                type="button"
                value="UPDATE PROFILE"
                onClick={modeChange}
                disabled={
                  mode === "UpdateProfile" &&
                  !(isAddressFormValid && valueChanged)
                }
              ></input>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Account;
